export default {
  path: 'id-cards',
  name: 'IdCards',
  component: () => import(/* webpackChunkName: "base" */ '../views/IdCardsView.vue'),
  meta: {
    exclude: false,
    requiresAuth: true
  }
}
